'use strict';

function run_view_more() {
	if (fed_powers) {

		// get view more container
		var viewMoreParent = fed_powers.get_arr('[data-view-more="parent"]');
		if (viewMoreParent.length > 0) {
			var hasColumnMultiplier = parseInt(viewMoreParent[0].dataset.columnMultiplier);
		}
		var targets = fed_powers.get_arr('[data-view-more="parent"] > *'),
			viewMoreLink = fed_powers.get_first_from('h3 .view-more'),
			viewMoreWrapper = fed_powers.get_first_from('.nr-view-more'),
			searchForm = fed_powers.get_first_from('.end-view-more'),
			searchInput = fed_powers.get_first_from('.nr-bottom-search .n-gateway-search-control');

		if (viewMoreLink) {

			var add_view_more_btn = function () {
				viewMoreLink.classList.add('active');
				viewMoreLink.addEventListener('click', show_next_round, false);
			};

			var show_next_round = function () {
				viewMoreWrapper.style.opacity = 0;
				var notActive = fed_powers.get_arr('[data-view-more="parent"] > [aria-hidden="true"]');
				let multiplier = hasColumnMultiplier ? hasColumnMultiplier : 6;
				var nextToShow = notActive.splice(0, multiplier);
				nextToShow.forEach(function (target) {
					target.setAttribute('aria-hidden', 'false');
					target.setAttribute('tabIndex', '1');
					target.classList.add('fade-up');
				});

				// show search form and if shown 24 or shown all available
				var activeItems = fed_powers.get_arr('[data-view-more="parent"] > [aria-hidden="false"]');
				// rerun, need new count after last iteration.
				var hiddenRecount = fed_powers.get_arr('[data-view-more="parent"] > [aria-hidden="true"]');
				if (activeItems.length == 24 && hiddenRecount.length > 0) {
					viewMoreLink.classList.remove('active');
					searchForm.classList.add('active');
				} else if (hiddenRecount.length === 0) {
					viewMoreLink.classList.remove('active');
					searchForm.classList.add('active');
				}

				// prevent seeing btn change...I know, is embarrassing - but simple.
				setTimeout(function () {
					viewMoreWrapper.style.opacity = 1;
				}, 500);
			};

			// Remove custom label on "Still Looking" form 2

			var replace_searchField_tag = function () {
				[].forEach.call(searchForm.querySelectorAll('[data-search-tag]'), function (tag) {
					var tagString = tag.getAttribute('data-search-tag');
					var searchLabel = tag.querySelector('.n-gateway-search-label');
					searchLabel.innerHTML = tagString;
				});
			};
			replace_searchField_tag();

			// how many targets
			if (viewMoreParent && viewMoreParent.length === 1) {
				if (Array.isArray(targets)) {
					var targetsCount = targets.length;

					if (targetsCount < 11) {
						targets.forEach(function (target) {
							target.setAttribute('aria-hidden', 'false');
						});
					} else if (targetsCount > 10 && targetsCount < 16) {
						let multiplier = hasColumnMultiplier ? (hasColumnMultiplier * 3) : (3 * 3);
						var firstAct = targets.slice(0, multiplier);
						firstAct.forEach(function (target) {
							target.setAttribute('aria-hidden', 'false');
						});

						add_view_more_btn();
					} else if (targetsCount >= 16) {
						let multiplier = hasColumnMultiplier ? (hasColumnMultiplier * 4) : (3 * 4);
						var _firstAct = targets.slice(0, multiplier);
						_firstAct.forEach(function (target) {
							target.setAttribute('aria-hidden', 'false');
						});

						add_view_more_btn();
					}
				}
			} else {
				// TODO: will extend here when there is the need for more than one "view more" pare page
			}

			if (searchInput) {

			}

		}	// end of test viewMoreLink

	}
}



//# sourceMappingURL=view_more.js.map

// publication pages - can have only 3 cards

document.addEventListener("DOMContentLoaded", function (event) {
	let viewMoreSections = fed_powers.get_arr('.newsr-cards');

	if (viewMoreSections.length > 0) {
		viewMoreSections.forEach((section) => {
			let cards = [].slice.call(section.querySelectorAll('.newsr-card'));
			let thisViewMore = section.querySelector('.nr-view-more');
			if (cards.length < 4) {
				thisViewMore.style.display = 'none';
			}
		})
	}
});

/*  v.xcvxcsd */